
(function(template){
define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/GroupMembersOtb',['Vue','vuex','helpers','underscore'],function(Vue,vuex,helpers,_){
    return {
        name: 'Group-Member-Otb',
        template: template,
        props: ['service', 'service_booked_time', 'isAgeValid'],
        data: function(){
            return {
                groupMembers: [],
                selected: false,
                selectedGroupMembers:[],
                newGroupMembers: [{FirstName: '', LastName: ''}],
                showAddGuest: false
            }
        },
        computed:  _.extend(vuex.mapState(['desktopMode','users','usersWithIds', 'OTBactive']),{
            customerName: function(){
                return app.data.FirstName + ' ' + app.data.LastName
            },
            disableSaveButton: function(){
                var nonNullNewGroupMembers = this.newGroupMembers.filter(function(gm){ return gm.FirstName.concat(gm.LastName).length > 0 });
                return this.selectedGroupMembers.concat(nonNullNewGroupMembers).length == 0;
            }
        }),
        methods: _.extend( vuex.mapMutations(['addGroupMember','addUserWithId']),
        {
            openAddGuest: function(){
                this.showAddGuest = true;
            },
            selectedUser: function(){

                var vm = this;
                var userFound = _.find(this.groupMembers, function(el){ return el.id == _.keys(vm.users)[0] });
                if(userFound){
                    return userFound.name;
                }

            },
            isUserSelected: function(userId){
                return _.keys(this.users).indexOf(userId) > -1;
            },
            handleSaveKeyDown: function(e) {
                e.target.click()
            },
            handleKeyDown: function(e, index){
                var vm = this;
                this.a11yKeyDown(e, {
                    down: function() {
                        e.preventDefault();
                        if(index == vm.groupMembers.length-1) return;
                        $('.groupMemberList .groupMember')[index+1].focus();
                    },
                    up: function() {
                        e.preventDefault();
                        if(index == 0) return;
                        $('.groupMemberList .groupMember')[index-1].focus();
                    },
                    shiftTab: function() {
                        if(!vm.fromApp) return;
                        e.preventDefault();
                        $('.content-spaPackageTpl #app #vue-cart .componentHeader .component-popup i').focus();
                    },
                    tab: function() {
                        e.preventDefault();
                        $('.addGuest .addGuestFields input')[0].focus();
                    },
                    enter: function() {
                        $('.groupMemberList .groupMember label')[index].click();
                        $('.groupMemberList .groupMember')[index].focus();
                    }
                })
            },
            handleCheckBoxClick : function(userSelected,userId){

                    var vm = this;
                    if(userSelected) return;


                    var currentUserId = _.keys(this.users)[0];

                    this.$store.commit('removeGuestMember',{userId:currentUserId});

                    this.$store.commit('setScheduleBtnValidity', {
                            action: "remove",
                            removeAll: true
                    })

                    vm.$store.commit('addUser',{userId:userId});
                    var ageCheck = this.verifyAge(this.service, userId);
                    vm.$store.commit('setIsAgeValid', ageCheck.isValid);

                    setTimeout(function(){
                        vm.$store.commit('addService',{service:vm.service, userId:userId, setSelected:true})
                        helpers.matchStoreWithFolio();
                    }, 100)


                    return;
            },
            handleClick : function(action){
                if(action == 'cancel'){
                    this.newGroupMembers = [{FirstName: '', LastName: ''}];
                    this.showAddGuest = false;
                    return;
                }
                if (!app.data.store) app.datal('store', {});
                if (!app.data.store.WebFolioId || app.data.store.WebFolioId != app.data.WebFolioId) app.datal('store', {
                    WebFolioId: app.data.WebFolioId,
                });
                app.datal('store', _.extend(app.data.store, {
                    groupMembersSelected: true
                }));
                if(this.disableSaveButton) {
                    if(this.desktopMode){
                        this.$store.commit('addGlobalMessage',{type: 'warn',message: this.localStrings.errors.noGuestSelected});
                            $('.messages-container')[0].scrollIntoView({block:'center',behavior: "smooth"});
                        }
                    else{
                          this.$store.commit('SetmobileViewMessages',{key: 'fail',message: this.localStrings.errors.noGuestSelected})
                         window.scrollTo({top: 0,left: 0,behavior: 'smooth'})
                    }
                return;
                };
                this.resolveInSeries(this.newGroupMembers,0, this);
                this.showAddGuest = false;
            },
            resolveInSeries: function(arr,index, vm ){
                if(index==arr.length){
                    this.newGroupMembers = [{FirstName: '', LastName: ''}];
                    return;
                };
                var member = arr[index];
                if(member.FirstName.concat(member.LastName).replace(/\s/g,'').length==0){
                    this.resolveInSeries(arr,index+1, vm);
                    return;
                };
                helpers.addGroupMember(member.FirstName,member.LastName).then(function(res) {
                    vm.groupMembers.push({name: member.FirstName+' '+member.LastName, id: res.newUserId});
                    vm.selectedGroupMembers.push(res.newUserId);
                    vm.resolveInSeries(arr,index+1, vm);
                }).fail(function(err){
                    alert(err);
                });
            }
        }),
        mounted: function(){
            var vm = this;
            vm.groupMembers.push({ name:this.customerName, id:app.data.CustomerId })
            helpers.fetchGroupMembers().then(function(groupMembers){
              
                groupMembers.GroupMember.forEach(function (member) {
                    var name = member.Name.FirstName + " " + member.Name.LastName;
                    if(_.findIndex(vm.groupMembers, function(item){ return item.id == member.CustomerId })){
                        vm.groupMembers.push({id:member.CustomerId, name:name});
                        vm.addGroupMember(name);
				        vm.addUserWithId({name: name, id: member.CustomerId});
                    }
                });
                vm.selectedGroupMembers = _.keys(vm.users);
            });

        },
        watch: {
            // newGroupMembers: {
            //     handler: function(arr) {
            //         var name = arr[arr.length-1];
            //         if(name.FirstName.concat(name.LastName).replace(/\s/g,'').length>0){
            //             this.newGroupMembers.push({FirstName: '', LastName: ''});
            //         }
            //     },
            //     deep: true
            // },
            users: function(val){
                var userIdsInStore = _.keys(val);
                this.selectedGroupMembers = this.selectedGroupMembers.filter(function(userId){
                    return userIdsInStore.indexOf(userId) > -1;
                })
            }
        }
    }
})
})('<div> <ul class="groupMemberOtb"> <div class="btn-group"> <h4 v-if="OTBactive && isAgeValid !== false">{{\'Service Recipient\'}}</h4> <a data-toggle="dropdown" :class="[\'btn dropdown-toggle focus-first\',{\'disable-staff-drop-down\': service_booked_time}]" href="#"> {{selectedUser()}} <span class="caret"></span> </a> <ul :class="[\'list dropdown-menu\',{\'ageRecepient\': isAgeValid === false}]" role="menu" > <li v-show="true" role="none" v-for="(member,index) in groupMembers" :key="index" :value="member.name" > <div tabindex="0" role="menuitem" @click="handleCheckBoxClick(isUserSelected(member.id),member.id)">{{member.name}} </div> <div tabindex="0" role="menuitem" @click="handleCheckBoxClick(isUserSelected(member.id),member.id)">{{member.name}} </div> <div tabindex="0" role="menuitem" @click="handleCheckBoxClick(isUserSelected(member.id),member.id)">{{member.name}} </div> </li> <li @click="openAddGuest"><div tabindex="0">{{localStrings.stepper.body.schedule.otb.addGuestLabel}}</div></li> </ul> </div> </ul> <div class="addGuest" v-if="showAddGuest"> <h4>{{localization.spaBooking.packageBooking.modeSelector.newGuestText}}</h4> <div class="addGuestFields" v-for="(guest,index) in newGroupMembers" :key="index"> <input type="text" class="customTextInput" placeholder="First Name" aria-label="Guest First Name" v-model="guest.FirstName" /> <input type="text" class="customTextInput" placeholder="Last Name" aria-label="Guest Last Name" v-model="guest.LastName" /> </div> <button class="btn customBlueButton" :disabled="disableSaveButton" @click="handleClick">{{localization.spaBooking.packageBooking.modeSelector.saveButonText}}</button> <button class="btn customBlueButton" :disabled="disableSaveButton" @click="handleClick(\'cancel\')">{{localStrings.stepper.body.schedule.otb.addGuestCancelBtn}}</button> </div> </div>');
